import { Tooltip } from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as Approval } from 'assets/svgs/approve-outline-20.svg';
import { ReactComponent as Freeze } from 'assets/svgs/freeze.svg';
import { Button } from 'components/atoms/button';
import { humanise } from 'components/atoms/humanised-date';
import { PermissionRuleName } from 'constant';
import { useGetUserFromIndexedDb } from 'hooks/use-idb';
import { FreezeAction } from '../../document.types';

interface Props {
  onUnfreeze: () => void;
  onReqApproval: () => void;
  docFreeze: FreezeAction;
  hideApprovalBtn: boolean;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ToolbarHelp = styled.div`
  display: flex;
  align-items: center;
  line-height: 32px;
`;

export const FreezeToolbar: FC<Props> = ({
  onUnfreeze,
  onReqApproval,
  docFreeze,
  hideApprovalBtn,
}) => {
  const user = useGetUserFromIndexedDb(docFreeze.frozenBy);

  return (
    <Wrapper>
      <Tooltip
        title={
          <FormattedMessage
            id="document.freeze_by_exact"
            values={{
              time: moment(docFreeze.frozenAt).calendar(),
            }}
          />
        }
        placement="bottom"
      >
        <ToolbarHelp>
          <FormattedMessage
            id="document.freeze_by"
            values={{
              user: user?.firstName,
              time: humanise(moment(docFreeze.frozenAt)),
            }}
          />
        </ToolbarHelp>
      </Tooltip>
      <Tooltip title={<FormattedMessage id="document.unfreeze_tooltip" />}>
        <Button
          type="link"
          icon={<Freeze />}
          size="small"
          onClick={onUnfreeze}
          ruleName={PermissionRuleName.SpaceDocumentFreezeAction}
        >
          <FormattedMessage id="document.unfreeze" />
        </Button>
      </Tooltip>
      {!hideApprovalBtn && (
        <Tooltip
          title={<FormattedMessage id="document.req_approval_tooltip" />}
        >
          <Button
            type="link"
            icon={<Approval />}
            size="small"
            onClick={onReqApproval}
          >
            <FormattedMessage id="document.req_approval" />
          </Button>
        </Tooltip>
      )}
    </Wrapper>
  );
};
